import { useTheme } from "@emotion/react";
import {
  CalendarTodayOutlined,
  ContentCopy,
  StarBorderOutlined,
  SupportAgentOutlined,
  VisibilityOutlined,
} from "@mui/icons-material";
import {
  Button,
  Chip,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import apiCliente from "../../../services/apiCliente";
import { StatusIconCard } from "../../../utils/chipsErp/chipStatusCard";
import TicketModalContent from "../detailsTicketComponent";
import ModalAvaliacaoComponent from "../modalAvaliacaoComponent";
import useStyles from "./styles";
import { getErpPrincipal } from "../../../services/erpSistema";

export default function TicketComponentClient(params) {
  const {
    protocolo = "",
    descricao = "",
    dataCadastro = "",
    usuarioAbertura = "",
    status = 1,
    ticketId = "",
    getTicketDetails = () => {},
    getForm = () => {},
    isEdit = false,
    isAvaliado = false,
    formId = null,
    createAnswerForm = () => {},
    setSnackbar = () => {},
    servicoId = "",
    labelErp = "",
    allInfoTicket = {},
    // ERP do cliente logado (portal); sem ele, a variável do front.
    erp: erpProp,
    // ERP do ticket (grupo econômico: o da empresa dona, vindo da lista) —
    // vai nas ações do ticket; o backend só aceita um ERP do grupo.
    erpId,
  } = params;
  const theme = useTheme();
  const erp = erpProp || getErpPrincipal();

  const styles = useStyles(theme);
  const [open, setOpen] = useState(false);
  const [openAvaliacao, setOpenAvaliacao] = useState(false);
  const [loading, setLoading] = useState(true);
  const [ticketDetails, setTicketDetails] = useState({});
  const [value, setValue] = useState(0);
  const [questions, setQuestions] = useState([]);
  const [viewed, setViewed] = useState(false);

  const [itensPublic, setItensPublic] = useState({
    mensagens: [],
    anexos: [],
  });
  const cliente = JSON.parse(localStorage.getItem("userCliente"));
  const configPermissao = cliente?.usuarioCliente?.cliente?.configPermissao;

  const labelTabsErp = {
    descricao:
      erp === "HUBSOFT"
        ? "Descrição"
        : erp === "VOALLE"
          ? "Geral"
          : "Descrição",
    mensagens:
      erp === "HUBSOFT"
        ? "Mensagens"
        : erp === "VOALLE"
          ? "Histórico"
          : "Mensagens",
  };

  function htmlForText(html) {
    if (!html) return "";

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    function extrairTexto(node) {
      let texto = "";

      node.childNodes.forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
          texto += child.textContent;
        } else if (child.nodeType === Node.ELEMENT_NODE) {
          const tag = child.tagName;

          switch (tag) {
            case "BR":
              texto += "\n";
              break;
            case "P":
            case "DIV":
              texto += extrairTexto(child) + "\n";
              break;
            case "LI":
              texto += "- " + extrairTexto(child) + "\n";
              break;
            case "UL":
            case "OL":
              texto += extrairTexto(child) + "\n";
              break;
            default:
              texto += extrairTexto(child);
          }
        }
      });

      return texto;
    }

    // Extrai texto e normaliza múltiplas quebras de linha
    const resultado = extrairTexto(tempDiv);
    return resultado.replace(/\n{3,}/g, "\n\n").trim();
  }

  const handleChange = (event, newValue) => {
    //adicionar viewed
    if (newValue === 1 && !viewed && ticketDetails) {
      viewedItens();
    }
    setValue(newValue);
  };
  const handleCloseAvaliacao = () => {
    setOpenAvaliacao(false);
  };
  const handleOpen = async () => {
    setOpen(true);
    setLoading(true);
    const response = await getTicketDetails(ticketId, erpId);

    setTicketDetails(response || {});
    setItensPublic((prev) => {
      const mensagens = [];
      const anexos = [];
      const anexosCliente = [];

      for (const item of response?.itensTicketPublic || []) {
        if (item?.itemType === "mensagem") {
          mensagens.push(item.itemId);
        } else if (item?.itemType === "anexo") {
          anexos.push(item.itemId);
        } else if (item?.itemType === "anexoCliente") {
          anexosCliente.push(item.itemId);
        }
      }

      return {
        ...prev,
        mensagens,
        anexos,
        anexosCliente,
      };
    });
    setLoading(false);
  };

  const handleOpenAvaliacao = async () => {
    setOpenAvaliacao(true);
    const response = await getForm(formId);
    setQuestions(response?.questions);
  };
  const handleClose = () => {
    setOpen(false);
    setValue(0);
    setViewed(false);
  };
  const statusChamado = {
    aguardando_analise: 1,
    resolvido: 2,
    pendente: 3,

    Cancelado: 4,
    Aberto: 5,
    Encaminhado: 6,
    Agendado: 7,
    "Em Análise": 8,
    Assumido: 9,
    "Em execução": 10,
    Finalizado: 11,
    Deslocamento: 12,
    Reagendar: 13,
    NA: 14,
  };

  const convertStatusVoalle = {
    1: "Aguardando Análise",
    2: "Resolvido",
    3: "Pendente",
    4: "Cancelado",
  };

  const viewedItens = async () => {
    try {
      await apiCliente.post("/cliente/ticket/itens/viewed", {
        erpId,
        itensId: ticketDetails?.atendimento_mensagem?.map((item) =>
          item?.id_atendimento_mensagem?.toString(),
        ),
      });

      setViewed(true);
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Erro ao visualizar mensagens",
        severity: "error",
      });
    } finally {
    }
  };

  return (
    <Paper
      elevation={theme.palette.mode == "dark" ? 0 : 3}
      sx={styles.paperContainer}
    >
      {StatusIconCard([statusChamado[status]])}

      <Box sx={styles.containerHeader}>
        <Box sx={styles.boxProtocolo}>
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: "bold",
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.colors.black.light
                  : theme.palette.colors.black.medium,
            }}
          >
            {" "}
            Protocolo:
          </Typography>
          <Typography
            sx={{
              ...styles.titleProtocolo,
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.primary.main
                  : theme.palette.tertiary.main,
            }}
          >
            {protocolo || ""}
          </Typography>
          <Tooltip title="Clique para copiar">
            <IconButton
              size="small"
              onClick={async () => {
                try {
                  await navigator.clipboard.writeText(protocolo);
                } catch (err) {
                  // Fallback para navegadores mais antigos ou sem permissão
                  const textArea = document.createElement("textarea");
                  textArea.value = protocolo;
                  document.body.appendChild(textArea);
                  textArea.select();
                  try {
                    document.execCommand("copy");
                  } catch (err) {
                    console.error("Falha ao copiar texto: ", err);
                  }
                  document.body.removeChild(textArea);
                }
                setSnackbar({
                  children: "Campo copiado!",
                  severity: "info",
                });
              }}
            >
              <ContentCopy sx={{ fontSize: "15px" }} />
            </IconButton>
          </Tooltip>
        </Box>
        <Box sx={styles.boxProtocolo}>
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: "bold",
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.colors.black.light
                  : theme.palette.colors.black.medium,
            }}
          >
            {" "}
            {labelErp} ID:
          </Typography>
          <Typography
            sx={{
              ...styles.titleProtocolo,
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.primary.main
                  : theme.palette.tertiary.main,
            }}
          >
            {servicoId}
          </Typography>

          <Tooltip title="Clique para copiar">
            <IconButton
              size="small"
              onClick={async () => {
                try {
                  await navigator.clipboard.writeText(servicoId);
                } catch (err) {
                  // Fallback para navegadores mais antigos ou sem permissão
                  const textArea = document.createElement("textarea");
                  textArea.value = servicoId;
                  document.body.appendChild(textArea);
                  textArea.select();
                  try {
                    document.execCommand("copy");
                  } catch (err) {
                    console.error("Falha ao copiar texto: ", err);
                  }
                  document.body.removeChild(textArea);
                }
                setSnackbar({
                  children: "Campo copiado!",
                  severity: "info",
                });
              }}
            >
              <ContentCopy sx={{ fontSize: "15px" }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <Box sx={styles.containerDescription}>
        <Typography sx={styles.description}>
          {" "}
          {(erp === "HUBSOFT" && descricao) ||
            (erp === "VOALLE" && htmlForText(descricao)) ||
            (erp === "IXC" && descricao)}
        </Typography>
      </Box>
      <Box sx={styles.boxInfos}>
        <Box sx={styles.containerInfo}>
          <CalendarTodayOutlined
            sx={{
              ...styles.icon,
              color:
                theme.palette.mode == "dark"
                  ? theme.palette.colors.black.light
                  : theme.palette.colors.black.medium,
              fontSize: "18px",
            }}
          />{" "}
          <Typography sx={styles.cardDescricao}>
            {dataCadastro || ""}
          </Typography>
        </Box>
        <Box
          sx={{
            ...styles.containerInfo,
            display: "flex",
            alignItems: "center",
            minWidth: 0,
          }}
        >
          <SupportAgentOutlined
            sx={{
              ...styles.icon,
              flexShrink: 0, // Garante que o ícone não mude de tamanho
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.primary.main
                  : theme.palette.tertiary.main,
            }}
          />

          <Tooltip
            title={
              allInfoTicket?.usuario_responsavel?.length > 0 ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 0.5,
                    padding: "4px",
                  }}
                >
                  {allInfoTicket.usuario_responsavel.map((u, index) => (
                    <Typography
                      key={u.id || index}
                      variant="caption"
                      sx={{
                        display: "block",
                        whiteSpace: "normal", // Permite a quebra de linha natural
                        wordBreak: "break-word",
                      }}
                    >
                      • {u.name}
                    </Typography>
                  ))}
                </Box>
              ) : (
                ""
              )
            }
            arrow
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                minWidth: 0,
                flex: 1,
              }}
            >
              <Typography
                noWrap
                sx={{
                  ...styles.cardDescricao,
                  fontWeight: "bold",
                  minWidth: 0, // Reforça o truncamento
                  color:
                    theme.palette.mode === "dark"
                      ? theme.palette.primary.main
                      : theme.palette.tertiary.main,
                }}
              >
                {allInfoTicket?.usuario_responsavel?.[0]?.name ||
                  "Sem responsável"}
              </Typography>

              {allInfoTicket?.usuario_responsavel?.length > 1 && (
                <Chip
                  label={`+${allInfoTicket.usuario_responsavel.length - 1}`}
                  size="small"
                  sx={{
                    fontWeight: "bold",
                    flexShrink: 0,
                    height: 20,
                    fontSize: "0.75rem",
                    backgroundColor: "primary.main",
                    color: "primary.contrastText",
                  }}
                />
              )}
            </Box>
          </Tooltip>
        </Box>
        <Box sx={styles.containerInfo}>{/*  */}</Box>
        <Box sx={styles.containerButton}>
          {formId && !isAvaliado && (
            <Button
              onClick={handleOpenAvaliacao}
              sx={{
                ...styles.buttonDetails,
                color: theme.palette.colors.black.dark,
              }}
              startIcon={<StarBorderOutlined />}
              variant="contained"
              size="small"
            >
              Avaliar
            </Button>
          )}

          <Button
            onClick={handleOpen}
            sx={styles.buttonDetails}
            startIcon={<VisibilityOutlined />}
            variant="outlined"
            size="small"
          >
            Detalhes
          </Button>
        </Box>
      </Box>

      <TicketModalContent
        open={open}
        loading={loading}
        handleClose={handleClose}
        erp={erp}
        erpId={erpId}
        ticketDetails={ticketDetails}
        convertStatusVoalle={convertStatusVoalle}
        status={statusChamado[status]}
        labelTabsErp={labelTabsErp}
        value={value}
        handleChange={handleChange}
        isEdit={isEdit}
        setTicketDetails={setTicketDetails}
        itensPublic={itensPublic}
        setItensPublic={setItensPublic}
        htmlForText={htmlForText}
        setSnackbar={setSnackbar}
        isCliente={true}
        canSendMessage={configPermissao?.sendMessage || false}
        canSendAnexo={configPermissao?.sendAnexo || false}
      />

      <ModalAvaliacaoComponent
        open={openAvaliacao}
        handleClose={handleCloseAvaliacao}
        questions={questions}
        createAnswerForm={createAnswerForm}
        formId={formId}
        ticketId={ticketId}
      />
    </Paper>
  );
}
